import { Component, inject, Input } from '@angular/core';

import { Portals } from '@qwyk/models';
import { AuthenticationFacade } from '@qwyk/portals/authentication';

import { ProofOfDeliveryFacade } from '../../+state/proof-of-delivery.facade';

@Component({
    selector: 'qwyk-proof-of-delivery-view',
    templateUrl: './proof-of-delivery-view.component.html',
    styleUrls: ['./proof-of-delivery-view.component.scss'],
})
export class ProofOfDeliveryViewComponent {

    private auth = inject(AuthenticationFacade);
    private proofOfDeliveries = inject(ProofOfDeliveryFacade);

    @Input() public small = false;
    @Input() columnSize = 'col-12 col-md-6';
    @Input() routerLink = null;
    @Input() routerLinkQueryParams = null;
    @Input()
    public set parent(parent: Portals.ParentEntity) {
        this.onParentChanged(parent);
    }

    public loading$ = this.proofOfDeliveries.loaded$;
    public dateFormat$ = this.auth.dateFormat$;
    public proofOfDelivery$ = this.proofOfDeliveries.getProofDelivery$;

    private onParentChanged(parent: Portals.ParentEntity) {
        this.proofOfDeliveries.init(parent);
    }
}
